module.exports = __webpack_public_path__ + "img/L2_zoom.f8dcccde.svg";